import styled from '@emotion/styled';
import { Typography } from 'src/components-dummy';

export const SubTitleTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom['gray-10']};
  margin: 10px 0;
`;
